import { Directive, inject, Injector, input, type OnInit, signal } from '@angular/core';
import type { NgControl } from '@angular/forms';
import { type FormControl } from '@angular/forms';
import { injectFormControl } from './inject-form-control';

@Directive({})
export abstract class BaseDelegatedFormControlComponent<T> implements OnInit {
  protected readonly injector = inject(Injector);
  // TODO check why do not work HostAttributeToken
  readonly nameAttribute = input.required<string>();
  protected readonly isDisabled = signal(false);

  /**
   * Only available after ngOnInit!
   */
  protected ngControl!: NgControl;
  /**
   * Only available after ngOnInit!
   */
  protected delegatedControl!: FormControl<T>;

  ngOnInit(): void {
    this.initControl();
  }

  protected initControl(): void {
    /**
     * Originally it would be enough to call it from constructor, but if `formControlName` is used,
     * it won't resolve, so it needs to be called from here
     */
    const { control, ngControl } = injectFormControl<T>(this.injector);
    this.delegatedControl = control;
    this.ngControl = ngControl;
  }
}
